/** @griffel:css-start [d] null **/
.f1qcbe8p{min-height:100dvh;}
.f1ewtqcl{box-sizing:border-box;}
.f22iagw{display:flex;}
.f122n59{align-items:center;}
.f4d9j23{justify-content:center;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.fg89v1a{padding-block:var(--spacingVerticalXXL);}
.fjshy37{padding-inline:var(--spacingHorizontalL);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1dmdbja{background-color:var(--colorNeutralBackground2);}
.f19n0e5{color:var(--colorNeutralForeground1);}
.f1xuog5c{max-width:520px;}
.fly5x3f{width:100%;}
.f1vx9l62{flex-direction:column;}
.f6jr5hl{align-items:flex-start;}
.f1noh358{row-gap:var(--spacingVerticalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.fg89v1a{padding-block:var(--spacingVerticalXXL);}
.fnsi1rm{padding-inline:var(--spacingHorizontalXXL);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fxugw4r{background-color:var(--colorNeutralBackground1);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1o0qvyv{border-radius:var(--borderRadiusLarge);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fz58gqq{box-shadow:var(--shadow8);}
.fkhj508{font-size:var(--fontSizeBase300);}
.f1i3iumi{line-height:var(--lineHeightBase300);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1pws37>*{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f16muhyy{color:var(--colorBrandForeground1);}
.fni485r{flex-wrap:wrap;}
.fsnqrgy{column-gap:var(--spacingHorizontalS);}
.f1wn3y0l{row-gap:var(--spacingVerticalS);}
/** @griffel:css-end **/